import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const startEndTrip = () => {
  return (
    <div className="destination">
      <Row className="justify-content-center">
        <Col md={12} lg={10}>
          <div className="start-end">
            <div>TRIP START</div>

            <div>TRIP END</div>
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={12} lg={10}>
          <div className="ellipse">
            <div class="Ellipse-55"> </div>

            <div class="Ellipse-57"></div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg={12}>
          <div className="date">
            <div class="date-range">
              Sat,25 jun'22,
              <br />
              08:30 AM
            </div>
            <div class="date-range">
              Sat,25 jun'22,
              <br />
              08:30 AM
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default startEndTrip;
